$(document).ready(function() {
  if ($('#chat-messages').length === 0) return;

  let currentConversationId = null;
  let allConversations = [];
  let isSending = false;

  // CSRF token — house pattern: read the hidden input rendered by {% csrf_token %}
  function csrfToken() {
    return $('[name=csrfmiddlewaretoken]').val();
  }

  marked.use({ gfm: true, breaks: true });

  const $chatMessages = $('#chat-messages');
  const $messagesContainer = $('#messages-container');
  const $chatInput = $('#chat-input');
  const $chatForm = $('#chat-form');
  const $sendBtn = $('#send-btn');
  const $typingIndicator = $('#typing-indicator');
  const $newChatBtn = $('#new-chat-btn');
  const $toggleHistoryBtn = $('#toggle-history-btn');
  const $chatHistorySidebar = $('#chat-history-sidebar');
  const $historyList = $('#chat-history-list');
  const $searchBtn = $('#search-btn');
  const $recentsBtn = $('#recents-btn');
  const $recentsDropdown = $('#recents-dropdown');
  const $searchModal = $('#search-modal');
  const $searchInput = $('#search-input');
  const $searchResults = $('#search-results');
  const $searchClose = $('#search-close');
  const $clarifyPanel = $('#clarify-panel');
  const $clarifyQuestion = $('#clarify-question');
  const $clarifyOptions = $('#clarify-options');

  // Navigate (full page load) so the server serves the conversation and the
  // template (jinja) hands the id back to the page. id=null => new chat
  // (?new=1 so the server doesn't reopen the last conversation).
  function goToConversation(id) {
    window.location.href = id ? ('/ai/chat/c/' + id) : '/ai/chat?new=1';
  }

  // The sidebar's "AI C-Suite" link opens /ai/chat; the server reopens the
  // conversation stored in this cookie so leaving the page doesn't reset it.
  function rememberConversation(id) {
    document.cookie = 'ai_last_conv=' + (id || '') + '; path=/; max-age=' + (id ? 2592000 : 0) + '; samesite=Lax';
  }

  // ─── Helpers ───
  function escapeHTML(str) {
    return String(str).replace(/[&<>'"]/g, t => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[t]||t));
  }
  function conversationItemHTML(c) {
    const title = c.title || 'New Chat';
    const activeClass = c.id === currentConversationId ? 'active' : '';
    return `<button class="history-item cursor-pointer w-full text-left px-2.5 py-2 mb-0.5 rounded-lg text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all flex items-center gap-2 group border border-transparent ${activeClass}" data-id="${c.id}" title="${escapeHTML(title)}">
        <span class="truncate flex-1 text-[13px]">${escapeHTML(title)}</span>
        <span class="history-rename cursor-pointer text-slate-400 hover:text-[#ff7a00] text-xs flex-shrink-0" title="Rename"><i class="bi bi-pencil"></i></span>
        <span class="history-delete cursor-pointer text-slate-400 hover:text-red-500 text-xs flex-shrink-0" title="Delete"><i class="bi bi-trash3"></i></span>
      </button>`;
  }
  function groupedListHTML(list) {
    if (!list || !list.length) return '<div class="text-center text-slate-400 text-sm py-6">No conversations</div>';
    const now = new Date();
    const today = now.toDateString();
    const yesterday = new Date(now - 86400000).toDateString();
    const groups = { 'Today': [], 'Yesterday': [], 'This Week': [], 'Earlier': [] };
    list.forEach(c => {
      const d = new Date(c.updated_at); const ds = d.toDateString(); const diff = (now - d) / 86400000;
      if (ds === today) groups['Today'].push(c);
      else if (ds === yesterday) groups['Yesterday'].push(c);
      else if (diff < 7) groups['This Week'].push(c);
      else groups['Earlier'].push(c);
    });
    let html = '';
    Object.entries(groups).forEach(([label, items]) => {
      if (!items.length) return;
      html += `<div class="history-group text-[11px] font-semibold text-slate-400 uppercase tracking-wider mb-1 px-2 mt-3">${label}</div>`;
      items.forEach(c => { html += conversationItemHTML(c); });
    });
    return html;
  }

  // ─── Sidebar collapse ───
  // The collapsed state is rendered server-side from the `ai_sidebar` cookie
  // (so there's no reload flicker); JS only persists changes to that cookie.
  function setSidebarCookie(collapsed) {
    document.cookie = 'ai_sidebar=' + (collapsed ? 'collapsed' : 'expanded') + '; path=/; max-age=31536000; samesite=Lax';
  }
  function updateSidebarToggleIcon() {
    const collapsed = $chatHistorySidebar.hasClass('collapsed');
    $toggleHistoryBtn.html('<i class="bi ' + (collapsed ? 'bi-layout-sidebar-inset' : 'bi-layout-sidebar') + '"></i>');
    $toggleHistoryBtn.attr('title', collapsed ? 'Expand sidebar' : 'Collapse sidebar');
  }
  if ($toggleHistoryBtn.length && $chatHistorySidebar.length) {
    // Laptop-size screens: until the user picks a state themselves, start with the history
    // rail collapsed so the conversation gets the width (their toggle choice still wins).
    if (!/(?:^|;\s*)ai_sidebar=/.test(document.cookie) && window.innerWidth < 1440) {
      $chatHistorySidebar.addClass('collapsed');
    }
    updateSidebarToggleIcon();  // match the server-rendered state
    $toggleHistoryBtn.on('click', function() {
      $chatHistorySidebar.toggleClass('collapsed');
      setSidebarCookie($chatHistorySidebar.hasClass('collapsed'));
      updateSidebarToggleIcon();
      closeRecentsDropdown();
    });
  }

  // Mobile history toggle
  const $mobileHistBtn = $('#mobile-history-btn');
  if ($mobileHistBtn.length) {
    $mobileHistBtn.on('click', function() {
      $chatHistorySidebar.toggleClass('hidden flex').addClass('absolute inset-0 z-50 w-full md:w-72 md:relative');
    });
  }

  // ─── Collapsed "Recents" dropdown ───
  function renderRecentsDropdown() {
    $recentsDropdown.html('<div class="rd-title">Recents</div><div class="rd-list">' + groupedListHTML(allConversations) + '</div>');
  }
  function openRecentsDropdown() {
    renderRecentsDropdown();
    const top = $recentsBtn.length ? $recentsBtn.position().top : 8;
    $recentsDropdown.css('top', top + 'px').removeClass('hidden').addClass('open');
  }
  function closeRecentsDropdown() { $recentsDropdown.addClass('hidden').removeClass('open'); }
  if ($recentsBtn.length) {
    $recentsBtn.on('click', function(e) {
      e.stopPropagation();
      $recentsDropdown.hasClass('open') ? closeRecentsDropdown() : openRecentsDropdown();
    });
  }
  $(document).on('click', function(e) {
    if (!$(e.target).closest('#recents-dropdown, #recents-btn').length) closeRecentsDropdown();
  });

  // ─── Search modal ───
  function renderSearch(q) {
    const query = (q || '').trim().toLowerCase();
    const list = query ? allConversations.filter(c => (c.title || '').toLowerCase().includes(query)) : allConversations;
    let html = '<button class="search-newchat cursor-pointer w-full flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-sm font-medium text-slate-700 dark:text-slate-200 mb-1"><i class="bi bi-pencil-square"></i> New chat</button>';
    html += query && !list.length ? '<div class="text-center text-slate-400 text-sm py-6">No matches</div>' : groupedListHTML(list);
    $searchResults.html(html);
  }
  function openSearch() {
    $searchModal.removeClass('hidden').addClass('flex');
    $searchInput.val('');
    renderSearch('');
    setTimeout(() => $searchInput.focus(), 50);
  }
  function closeSearch() { $searchModal.addClass('hidden').removeClass('flex'); }
  if ($searchBtn.length) $searchBtn.on('click', function() { openSearch(); closeRecentsDropdown(); });
  if ($searchClose.length) $searchClose.on('click', closeSearch);
  $searchInput.on('input', function() { renderSearch($(this).val()); });
  $searchModal.on('click', function(e) { if (e.target === this) closeSearch(); });
  $(document).on('keydown', function(e) { if (e.key === 'Escape') { closeSearch(); closeRecentsDropdown(); } });
  $(document).on('click', '.search-newchat', function() { goToConversation(null); });

  // Enable/disable send and auto-resize textarea
  $chatInput.on('input', function() {
    const hasText = !!$.trim($chatInput.val());
    $sendBtn.prop('disabled', !hasText || isSending);
    this.style.height = '36px';
    this.style.height = (this.scrollHeight) + 'px';
    // Typing a new question dismisses the pending picker (the server also treats
    // an unrelated message as abandoning the clarification).
    if (hasText && !$clarifyPanel.hasClass('hidden')) hideClarify();
  });

  // Enter to send, Shift+Enter for new line
  $chatInput.on('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!$.trim($chatInput.val())) return;
      $chatForm.submit();
    }
  });

  // Suggestion chips
  $(document).on('click', '.suggestion-chip', function() {
    $chatInput.val($(this).data('msg'));
    $sendBtn.prop('disabled', false);
    $chatForm.submit();
  });

  // ─── Send message ───
  $chatForm.on('submit', function(e) {
    e.preventDefault();
    const messageText = $.trim($chatInput.val());
    if (!messageText || isSending) return;
    isSending = true;

    hideClarify();
    $chatInput.val('');
    $chatInput.css('height', '36px');
    $sendBtn.prop('disabled', true);
    $('#welcome-screen').hide();

    appendMessage('user', messageText);
    $typingIndicator.addClass('hidden');
    $messagesContainer.append(`
      <div id="typing-bubble" class="flex justify-start animate-fade-in-up">
        <div class="flex gap-3 max-w-[95%] sm:max-w-[85%]">
          <div class="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
            <img src="/static/images/brand/ectlogo.png" alt="AI Bot" class="w-full h-full object-contain">
          </div>
          <div class="flex-1 min-w-0 flex items-center pt-2">
            <div class="flex gap-1.5 items-center px-1">
              <div class="w-1.5 h-1.5 bg-[#ff7a00] rounded-full animate-bounce" style="animation-delay:0ms"></div>
              <div class="w-1.5 h-1.5 bg-[#ff7a00] rounded-full animate-bounce" style="animation-delay:150ms"></div>
              <div class="w-1.5 h-1.5 bg-[#ff7a00] rounded-full animate-bounce" style="animation-delay:300ms"></div>
            </div>
          </div>
        </div>
      </div>
    `);
    scrollToBottom();

    $.ajax({
      url: '/ai/chat/message',
      method: 'POST',
      contentType: 'application/json',
      headers: { 'X-CSRFToken': csrfToken() },
      data: JSON.stringify({ message: messageText, conversation_id: currentConversationId }),
      complete: function() {
        isSending = false;
        $sendBtn.prop('disabled', !$.trim($chatInput.val()));
      },
      success: function(data) {
        $typingIndicator.addClass('hidden');
        $('#typing-bubble').remove();
        if (data.status === 'ok' && data.response) {
          appendMessage('assistant', data.response);
          if (data.input === 'month' || (data.options && data.options.length)) {
            showClarify(data.response, data.options || [], data.input);
          }
          if (data.conversation_id) {
            currentConversationId = data.conversation_id;
            rememberConversation(data.conversation_id);
            // Put the conversation id in the URL silently (no page reload) so a
            // refresh re-serves it and the template loads it back.
            window.history.replaceState(null, '', '/ai/chat/c/' + data.conversation_id);
          }
          setTimeout(loadConversations, 1500);
        } else {
          appendMessage('assistant', data.error || "Sorry, I couldn't process that. Please try again.");
        }
      },
      error: function(xhr) {
        $typingIndicator.addClass('hidden');
        $('#typing-bubble').remove();
        // Show the server's own message (rate limit, too long, AI unavailable…).
        const serverMsg = xhr.responseJSON && xhr.responseJSON.error;
        appendMessage('assistant', serverMsg || "Error communicating with AI service. Please check your connection.");
        console.error('Chat error:', xhr);
        // Only a network failure or a server/AI failure means the AI may be down —
        // reflect it on the badge, then re-probe /ai/status for the specific reason.
        if (!xhr.status || xhr.status >= 500) {
          setStatus(false, 'error');
          checkStatus();
        }
      }
    });
  });

  // New Chat
  if ($newChatBtn.length) {
    $newChatBtn.on('click', function() { goToConversation(null); });
  }

  // ─── Append Message ───
  function appendMessage(role, content) {
    let html = '';
    if (role === 'user') {
      html = `
        <div class="flex justify-end animate-fade-in-up">
          <div class="max-w-[85%] sm:max-w-[70%]">
            <div class="bg-[#ff7a00] text-white px-4 py-2.5 rounded-2xl rounded-tr-sm text-sm shadow-md">
              <p class="leading-relaxed whitespace-pre-wrap">${escapeHTML(content)}</p>
            </div>
          </div>
        </div>`;
    } else {
      // markdown -> sanitize -> wrap any tables in a styled, horizontally-scrollable container
      const $rendered = $('<div>').html(DOMPurify.sanitize(marked.parse(content)));
      $rendered.find('table').each(function() { $(this).wrap('<div class="ai-table-wrap"></div>'); enhanceTable($(this)); });
      const sanitizedContent = $rendered.html();
      html = `
        <div class="flex justify-start animate-fade-in-up">
          <div class="flex gap-3 max-w-[95%] sm:max-w-[85%]">
            <div class="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
              <img src="/static/images/brand/ectlogo.png" alt="AI Bot" class="w-full h-full object-contain">
            </div>
            <div class="flex-1 min-w-0">
              <div class="text-sm text-slate-800 dark:text-slate-200 ai-content leading-relaxed">${sanitizedContent}</div>
              <button class="copy-btn cursor-pointer mt-1.5 text-xs text-slate-400 hover:text-[#ff7a00] transition-colors flex items-center gap-1" title="Copy response">
                <i class="bi bi-clipboard text-xs"></i> Copy
              </button>
            </div>
          </div>
        </div>`;
    }
    $messagesContainer.append(html);
    scrollToBottom();
  }

  // Make AI tables readable: status badges, right-aligned numbers, short columns kept
  // on one line, and long comma lists (e.g. assigned workers) shown as chips collapsed
  // to the first few with a "+N more" toggle. Every value stays in the DOM (hidden
  // separators included) so Copy still returns the full text.
  const TABLE_LIST_PREVIEW = 3;
  const STATUS_CLASS = { active: 'ok', completed: 'done', overdue: 'bad', cancelled: 'muted', pending: 'warn' };
  function splitList(text) {
    // split on commas that are not inside parentheses: "efg (ertg erg), zara" -> 2 items
    const out = []; let depth = 0, cur = '';
    for (const ch of text) {
      if (ch === '(') depth++;
      if (ch === ')') depth = Math.max(0, depth - 1);
      if (ch === ',' && depth === 0) { out.push(cur.trim()); cur = ''; } else cur += ch;
    }
    if (cur.trim()) out.push(cur.trim());
    return out.filter(Boolean);
  }
  function enhanceTable($table) {
    const headers = $table.find('thead th').map(function () { return $(this).text().trim().toLowerCase(); }).get();
    if (headers.length === 1 && $table.find('tbody tr').length > 6) $table.closest('.ai-table-wrap').addClass('ai-onecol');
    $table.find('tbody td').each(function () {
      const $td = $(this);
      // Block / sub-block / task numbers are codes, not quantities — keep them left-aligned.
      const isCode = /block|code|task no|round/.test(headers[$td.index()] || '');
      if ($td.children().length) return;   // leave cells with markup (links, bold) alone
      const text = $td.text().trim();
      const status = STATUS_CLASS[text.toLowerCase()];
      if (status) {
        $td.html(`<span class="ai-badge ai-badge-${status}">${escapeHTML(text)}</span>`);
        return;
      }
      if (!isCode && /^[-+]?[\d,]*\.?\d+\s*(%|ha|mt|kg|rm)?$/i.test(text)) { $td.addClass('ai-num'); return; }
      const items = splitList(text);
      if (items.length > 1) {
        const chip = (t, i, hidden) => `<span class="ai-chip${hidden ? ' ai-chip-more hidden' : ''}">${escapeHTML(t)}</span>` +
          (i < items.length - 1 ? '<span class="ai-sep">, </span>' : '');
        let html = items.map((t, i) => chip(t, i, i >= TABLE_LIST_PREVIEW)).join('');
        if (items.length > TABLE_LIST_PREVIEW) {
          html += `<button type="button" class="ai-chip-toggle" data-more="+${items.length - TABLE_LIST_PREVIEW} more">+${items.length - TABLE_LIST_PREVIEW} more</button>`;
        }
        $td.addClass('ai-list').html(`<div class="ai-chips">${html}</div>`);
        return;
      }
      if (text.length > 40) $td.addClass('ai-wrap');
      else if (text.length > 14 && /\s/.test(text)) $td.addClass('ai-text');
    });
  }
  $(document).on('click', '.ai-chip-toggle', function () {
    const $btn = $(this);
    const $more = $btn.siblings('.ai-chip-more');
    const open = $more.first().hasClass('hidden');
    $more.toggleClass('hidden', !open);
    $btn.text(open ? 'Show less' : $btn.data('more'));
  });

  // Clarifying options as a Claude-Code-style picker just above the input.
  function optionRow(o, i) {
    return `
      <button class="clarify-opt cursor-pointer w-full text-left flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-slate-700 dark:text-slate-200 hover:bg-[#ff7a00]/10 hover:text-[#ff7a00] transition-colors" data-value="${escapeHTML(o.value)}" data-search="${escapeHTML((o.label + ' ' + o.value).toLowerCase())}">
        <span class="clarify-num w-5 h-5 flex items-center justify-center rounded bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-300 text-[11px] font-semibold flex-shrink-0 transition-colors">${i + 1}</span>
        <span class="truncate">${escapeHTML(o.label)}</span>
      </button>`;
  }
  function showClarify(question, options, input) {
    $clarifyQuestion.text(question || '').toggle(!!question);

    // Period questions use a native month picker (YYYY-MM) so the AI matches the
    // report pages, which only select a month + year — no free date ranges.
    if (input === 'month') {
      const now = new Date();
      const cur = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
      $clarifyOptions.html(`
        <div class="flex items-center gap-2 p-2">
          <input id="clarify-month" type="month" value="${cur}" max="${cur}"
            class="flex-1 text-sm px-3 py-1.5 rounded-lg border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-700/50 text-slate-800 dark:text-white focus:outline-none focus:border-[#ff7a00]">
          <button id="clarify-month-go" class="cursor-pointer px-4 py-1.5 rounded-lg bg-[#ff7a00] hover:bg-[#e66e00] text-white text-sm font-medium transition-colors flex-shrink-0">Continue</button>
        </div>`);
      $clarifyPanel.removeClass('hidden');
      $('#clarify-month').trigger('focus');
      scrollToBottom();
      return;
    }

    // Show a search box when the list is long (e.g. picking a worker from all workers).
    const searchable = options.length > 6;
    const searchBox = searchable
      ? `<div class="px-2 pt-1 pb-2 sticky top-0 bg-white dark:bg-slate-800 z-10">
           <input id="clarify-search" type="text" autocomplete="off" placeholder="Search…"
             class="w-full text-sm px-3 py-1.5 rounded-lg border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-700/50 text-slate-800 dark:text-white placeholder-slate-400 focus:outline-none focus:border-[#ff7a00]">
         </div>` : '';
    const rows = options.map((o, i) => optionRow(o, i)).join('');
    $clarifyOptions.html(searchBox + `<div id="clarify-list">${rows}</div>`);
    $clarifyPanel.removeClass('hidden');
    if (searchable) $('#clarify-search').trigger('focus');
    scrollToBottom();
  }
  function hideClarify() {
    $clarifyPanel.addClass('hidden');
    $clarifyOptions.empty();
  }

  // Live-filter the worker/option list as the user types in the picker search box.
  $(document).on('input', '#clarify-search', function() {
    const q = String($(this).val() || '').toLowerCase().trim();
    $('#clarify-list .clarify-opt').each(function() {
      const hay = String($(this).data('search') || '');
      $(this).toggle(q === '' || hay.indexOf(q) !== -1);
    });
  });

  // Picking an option sends its value as the next message.
  $(document).on('click', '.clarify-opt', function() {
    const val = $(this).data('value');
    hideClarify();
    $chatInput.val(String(val));
    $chatForm.submit();
  });

  // Month picker "Continue" — send the chosen YYYY-MM as the next message.
  $(document).on('click', '#clarify-month-go', function() {
    const val = $('#clarify-month').val();
    if (!val) { $('#clarify-month').trigger('focus'); return; }
    hideClarify();
    $chatInput.val(String(val));
    $chatForm.submit();
  });
  // Enter inside the month field also submits.
  $(document).on('keydown', '#clarify-month', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); $('#clarify-month-go').trigger('click'); }
  });

  $(document).on('click', '.copy-btn', function() {
    const $btn = $(this);
    const content = $btn.siblings('.ai-content').text();
    navigator.clipboard.writeText(content).then(() => {
      $btn.html('<i class="bi bi-check2 text-xs"></i> Copied!');
      setTimeout(() => { $btn.html('<i class="bi bi-clipboard text-xs"></i> Copy'); }, 2000);
    });
  });

  function scrollToBottom() {
    // The page (window) is the scroll container now — the chat area grows with
    // its content instead of scrolling inside a fixed-height box, so scroll the
    // whole document to the bottom.
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'auto' });
  }

  // ─── Conversation History ───
  function renderHistoryList() {
    $('#history-loading').addClass('hidden');
    const $empty = $('#history-empty');
    $historyList.find('.history-group, .history-item').remove();
    if (!allConversations.length) { $empty.removeClass('hidden'); return; }
    $empty.addClass('hidden');
    $historyList.append(groupedListHTML(allConversations));
  }

  function loadConversations() {
    $.ajax({
      url: '/ai/chat/conversations',
      method: 'GET',
      headers: { 'X-CSRFToken': csrfToken() },
      success: function(data) {
        allConversations = data.conversations || [];
        renderHistoryList();
        if ($recentsDropdown.hasClass('open')) renderRecentsDropdown();
      },
      error: function(err) {
        console.error('Failed to load conversations:', err);
        $('#history-loading').html('<span class="text-red-400 text-xs">Failed to load</span>');
      }
    });
  }

  // Clicking a conversation (sidebar list, recents dropdown, or search) navigates
  // to its URL — the server serves it and the template drives the load.
  $(document).on('click', '.history-item', function(e) {
    const id = $(this).data('id');
    if ($(e.target).closest('.history-rename').length) {
      e.stopPropagation();
      renameConversation(String(id));
      return;
    }
    if ($(e.target).closest('.history-delete').length) {
      e.stopPropagation();
      deleteConversation(id);
      return;
    }
    goToConversation(id);
  });

  // Render the messages of the conversation the server put in the template.
  function loadConversation(id) {
    $.ajax({
      url: `/ai/chat/conversations/${id}`,
      method: 'GET',
      headers: { 'X-CSRFToken': csrfToken() },
      success: function(data) {
        if (data.status !== 'ok') return;
        currentConversationId = id;
        $messagesContainer.children().not('#welcome-screen').remove();
        $('#welcome-screen').hide();
        data.messages.forEach(m => appendMessage(m.role, m.content));
        rememberConversation(id);
        // Conversation ended on an unanswered clarifying question -> reopen its picker.
        const last = data.messages[data.messages.length - 1];
        if (last && last.role === 'assistant' && (last.input === 'month' || (last.options && last.options.length))) {
          showClarify(last.content, last.options || [], last.input);
        }
        $('.history-item').removeClass('active');
        $(`.history-item[data-id="${id}"]`).addClass('active');
        scrollToBottom();
      },
      error: function(err) {
        console.error('Failed to load conversation:', err);
        rememberConversation(null);
        $('#welcome-screen').removeClass('hidden');  // stale/deleted id — don't leave a blank page
      }
    });
  }

  function renameConversation(id) {
    const convo = allConversations.find(c => c.id === id);
    const current = convo ? (convo.title || '') : '';
    const dlg = new Dialog(
      "Rename conversation",
      `<input id="rename-input" type="text" maxlength="100" autocomplete="off"
         class="w-full text-sm px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-white focus:outline-none focus:border-[#ff7a00]"
         value="${escapeHTML(current)}">`
    );
    function save() {
      const title = $.trim($('#rename-input').val());
      if (!title) { $('#rename-input').trigger('focus'); return; }
      if (title === current) { dlg.hide(); return; }
      $.ajax({
        url: `/ai/chat/conversations/${id}`,
        method: 'PATCH',
        contentType: 'application/json',
        headers: { 'X-CSRFToken': csrfToken() },
        data: JSON.stringify({ title: title }),
        success: function(data) {
          dlg.hide();
          if (convo) convo.title = data.title || title;
          renderHistoryList();
          if ($recentsDropdown.hasClass('open')) renderRecentsDropdown();
          if (window.Toast) Toast.show('Conversation renamed', 'success', 3000);
        },
        error: function(xhr) {
          const msg = (xhr.responseJSON && xhr.responseJSON.error) || 'Failed to rename conversation';
          if (window.Toast) Toast.show(msg, 'error', 4000);
        }
      });
    }
    dlg.setButtons([
      { name: "Cancel", dismiss: true },
      { name: "Save", class: "bg-[#ff7a00] text-white hover:bg-[#e66e00]", onClick: save }
    ]);
    dlg.setEvents([{ action: 'show', callback: function() {
      const $in = $('#rename-input');
      $in.trigger('focus').trigger('select');
      $in.on('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); save(); } });
    } }]);
    dlg.show();
  }

  function deleteConversation(id) {
    const dlg = new Dialog(
      "Delete conversation",
      "<p class='text-sm text-gray-600'>Are you sure you want to delete this conversation? This action can't be undone.</p>"
    );
    dlg.setButtons([
      { name: "Cancel", dismiss: true },
      {
        name: "Delete",
        class: "bg-red-600 text-white hover:bg-red-700",
        onClick: function() {
          $.ajax({
            url: `/ai/chat/conversations/${id}`,
            method: 'DELETE',
            headers: { 'X-CSRFToken': csrfToken() },
            success: function() {
              dlg.hide();
              if (window.Toast) Toast.show('Conversation deleted', 'success', 3000);
              // If the open conversation was deleted, go to a fresh chat; otherwise
              // just refresh the sidebar list.
              if (currentConversationId === id) { rememberConversation(null); goToConversation(null); }
              else loadConversations();
            },
            error: function(err) {
              console.error('Failed to delete conversation:', err);
              dlg.hide();
              if (window.Toast) Toast.show('Failed to delete conversation', 'error', 4000);
            }
          });
        }
      }
    ]);
    dlg.show();
  }

  // ─── AI backend status badge ───
  // Polls /ai/status (a token-free OpenAI reachability probe) and reflects the
  // result in the header badge, so users see Online/Offline instead of a badge
  // that always claims "Online". Also flipped to offline by a failed chat send.
  const $statusBadge = $('#ai-status-badge');
  const $statusDot = $('#ai-status-dot');
  const $statusText = $('#ai-status-text');
  const $statusDotMobile = $('#ai-status-dot-mobile');

  // reason -> human label shown when offline (hover title on the badge).
  const STATUS_REASONS = {
    auth: 'AI unavailable — API key invalid or missing',
    permission: 'AI unavailable — key not permitted for this model',
    quota: 'AI unavailable — quota exhausted or subscription ended',
    rate_limit: 'AI busy — rate limit reached, retrying shortly',
    down: 'AI unavailable — OpenAI service unreachable',
    error: 'AI unavailable — unexpected error',
    disabled: 'AI C-Suite is disabled by the administrator',
    network: 'AI status unknown — could not reach server',
  };

  function setStatus(online, reason) {
    if (!$statusBadge.length) return;
    if (online) {
      $statusBadge.attr('class', 'inline-flex items-center gap-1.5 bg-emerald-50 text-emerald-700 px-3 py-1 rounded-full text-xs font-medium border border-emerald-100 flex-shrink-0')
        .attr('title', 'AI is online');
      $statusDot.attr('class', 'w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse');
      $statusText.text('Online');
      $statusDotMobile.attr('class', 'w-2 h-2 rounded-full bg-emerald-500 animate-pulse');
    } else {
      $statusBadge.attr('class', 'inline-flex items-center gap-1.5 bg-red-50 text-red-600 px-3 py-1 rounded-full text-xs font-medium border border-red-100 flex-shrink-0')
        .attr('title', STATUS_REASONS[reason] || 'AI is offline');
      $statusDot.attr('class', 'w-1.5 h-1.5 bg-red-500 rounded-full');
      $statusText.text('Offline');
      $statusDotMobile.attr('class', 'w-2 h-2 rounded-full bg-red-500');
    }
  }

  function checkStatus() {
    $.ajax({ url: '/ai/status', method: 'GET', timeout: 12000 })
      .done(function(data) { setStatus(data && data.status === 'online', data && data.reason); })
      .fail(function() { setStatus(false, 'network'); });
  }

  if ($statusBadge.length) {
    checkStatus();                       // on load
    setInterval(checkStatus, 60000);     // re-check every 60s (token-free)
  }

  // ─── On load: populate the sidebar, and open the conversation the server
  //     placed in the template (data-conversation-id) if any. ───
  loadConversations();
  const initialId = $('#chat-root').data('conversationId');
  if (initialId) loadConversation(String(initialId));
});
